import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

import AspectRatioFixed, { Props as AspectRatioFixedProps } from './AspectRatioFixed';

type backgroundSizeValue = 'cover' | 'contain' | 'length' | 'percentage' | 'initial' | 'inherit' | 'auto';

type Props = AspectRatioFixedProps &
  ClassAttributes<HTMLElement> & {
    src: string;
    className?: string;
    backgroundSize?: backgroundSizeValue;
  };

type StyledComponentProps = {
  src: string;
  backgroundSize?: backgroundSizeValue;
};

const AspectRatioFixedImage = ({ aspectRatio, width, height, src, className, backgroundSize = 'contain' }: Props) => (
  <AspectRatioFixed {...{ aspectRatio, width, height, className, backgroundSize }}>
    <Image src={src} backgroundSize={backgroundSize} />
  </AspectRatioFixed>
);

const Image = styled('div')<StyledComponentProps>(({ src, backgroundSize }) => ({
  backgroundImage: `url(${src})`,
  backgroundSize,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
}));

export default AspectRatioFixedImage;
